<template>
	<div class="form-model-main">
		<div class="add-page-content">
			<div class="title">{{pageTitle}}</div>
			<div class="content">
				<a-form-model
						ref="ruleForm"
						:model="formData"
						:rules="rules"
						:label-col="labelCol"
						:wrapper-col="wrapperCol">
					<a-form-model-item ref="abbrev" label="简称" prop="abbrev">
						<a-input v-model="formData.abbrev" placeholder="请输入分子分型简称"/>
					</a-form-model-item>
					<a-form-model-item ref="fullName" label="全称" prop="fullName">
						<a-input v-model="formData.fullName" placeholder="请输入分子分型全称"/>
					</a-form-model-item>
					<a-form-model-item ref="parentId" label="父级" prop="parentId">
						<a-cascader
								:value="formData.parentIds"
								:options="options"
								placeholder="请选择父级"
								change-on-select
								@change="onChange"
						/>
					</a-form-model-item>
				</a-form-model>
				<div class="confrim-footer" v-if="!formData.system">
					<a-button @click="submitClick" type="primary" class="cf-mr10">确定</a-button>
					<a-button @click="cancelSubmit">取消</a-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
  export default {
    props: {
      editMtId: 0,
      layerSelectOption: {type: Array, default: []},
      editDataRow: {
        type: Object,
        default: () => {
        }
      }
    },
    data() {
      return {
        labelCol: {span: 24},
        wrapperCol: {span: 24},
        data: [],
        rules: {
          abbrev: {required: true, message: '请输入分子分型简称', trigger: 'blur'},
          fullName: {required: true, message: '请输入分子分型全称', trigger: 'blur'}
        },
        formData: {
          abbrev: '',
          fullName: '',
          parentId: -1,
          parentIds: undefined,
        },
        layerRow: [],
        options: [],
        pageTitle: "添加分子分型设置",
        isSubmit: false
      };
    },
    components: {},
    mounted() {
      this.getLayerLst(-1);
      if (this.editDataRow && this.editDataRow.id) {
        this.pageTitle = "编辑分子分型设置";
        this.getDetail(this.editDataRow.id);
      } else {
        this.pageTitle = "添加分子分型设置";
      }
    },
    methods: {
      getLayerLst(id) {
        this.$get('mt/q/mtt').then(res => {
          if (res.data.code == 1) {
            this.options = res.data.data;
          }
        })
      },
      getDetail(id) {
        let that = this;
        this.$post('mt/detail/' + id, {}, {
          "Content-Type": "application/json"
        }).then(res => {
          if (res.data.code == 1) {
            that.formData = Object.assign({}, that.formData, res.data.data)
          }
        })
      },
      loadData(selectedOptions) {
        console.log(',selectedOptions', selectedOptions)
        const targetOption = selectedOptions[selectedOptions.length - 1];
        targetOption.loading = true;
        this.$post('mt/query', {parentId: targetOption.value}, {
          "Content-Type": "application/json"
        }).then(res => {
          targetOption.loading = false;
          if (res.data.code == 1) {
            let resData = res.data.data;
            targetOption.children = [];
            resData.forEach((item, index) => {
              let json = {
                value: item.id,
                label: item.abbrev,
                isLeaf: false,
              };
              targetOption.children.push(json);
            });
            this.options = [...this.options];
          }
        })
      },
      onChange(value) {
        console.log(value);
        this.formData.parentId = value[value.length - 1];
        this.formData.parentIds = value;
      },
      submitClick() {
        this.$refs.ruleForm.validate(valid => {
          if (!valid) {
            return false;
          }
          let postUrl = '/mt/add';
          let mes = '添加';
          if (this.editMtId) {
            mes = '编辑';
            postUrl = 'mt/upt';
          }
          this.$post(postUrl, this.formData, {
            "Content-Type": "application/json"
          }).then(res => {
            if (res.data.code == 0) {
              this.$message.error(res.data.message);
            } else {
              this.$message.success(mes + "成功！");
              this.$emit("close");
            }
          })
        })
      },
      cancelSubmit() {
        this.$emit("close");
      }
    }
  };
</script>

<style lang="scss" scoped>
</style>